export default __webpack_public_path__ + "static/media/2184.95c734de.png";